import React, {useEffect, useState} from "react";

import {Box, Checkbox, FormControlLabel, IconButton} from "@mui/material";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {TreeView} from '@mui/x-tree-view/TreeView';
import {TreeItem} from '@mui/x-tree-view/TreeItem';
import {styled} from "@mui/material/styles";

const CheckboxCondensed  = styled(Checkbox)(({ theme }) => ({
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(0.5),
    paddingTop: 2,
    paddingBottom: 2
}));

const CustomTreeView = styled(TreeView)(({ theme }) => ({
    overflowX: 'hidden',
    overflowY: 'scroll',
}));

const MultiSelectTree = ({name = null, nodes, updateChoices, choices, choicesCount = []}) => {
    const [checked, setChecked] = useState(choices);
    const [expanded, setExpanded] = useState([]);

    useEffect(() => {
        if (choices.length === 0 && checked.length !== 0) {
            setChecked([]);
        }
    }, [nodes, choices, choicesCount]);

    useEffect(() => {
        if (name) {
            updateChoices(name, checked);
        } else {
            updateChoices(checked);
        }
    }, [checked])

    const handleCheck = (node, newValue) => {
        const value = checked.includes(node.id);
        let newValues = null
        if (!node.children || node.children.length === 0) {
            if (value === newValue) {
                console.log('exit');
                return;
            }
            newValues =  newValue
                ? [...checked, node.id]
                : checked.filter(id => id !== node.id);
        } else {
            const ids = leafIds(node);
            const remaining = checked.filter(id => !ids.includes(id));
            newValues = newValue ? [...remaining, ...ids] : remaining;

            //Lorsque l'on décoche, si aucun fils n'est présent, on retire la sélection
            if (!newValue && newValues.some(r=> ids.indexOf(r) === -1)) {
                newValues = newValues.filter(id => id != node.id);
            }

            if (!newValue) {
                newValues = newValues.filter(id => id != node.parentId);
            }

            if (newValue && newValues.length === node.children.length) {
                newValues.push(node.id);
            }
        }

        setChecked(newValues);
    };

    function TreeNode({ node }) {
        const isChecked = leafIds(node).every(id => checked.includes(id));
        const isIndeterminate =
            !isChecked && leafIds(node).some(id => checked.includes(id));
        const onChange = () => {
            handleCheck(node, !isChecked);
        };
        const nodeLabel = node.label + ((Array.isArray(choicesCount) && choicesCount[node.id]) ? " (" + choicesCount[node.id] + ")" : "");

        return (
            <TreeItem
                key={node.id}
                nodeId={"" + node.id}
                label={
                    <FormControlLabel
                        color="white"
                        style={{ marginBottom: "0px", padding: "5px 0px" }}
                        control={
                            <CheckboxCondensed
                                checked={isChecked}
                                value={"" + node.id}
                                onChange={onChange}
                                onClick={e => e.stopPropagation()}
                                indeterminate={isIndeterminate}
                            />
                        }
                        label={nodeLabel}
                        onClick={e => e.stopPropagation()}
                    />
                }
            >
                {node?.children.length > 0 && <TreeNodes nodes={node.children} />}
            </TreeItem>
        );
    }

    function TreeNodes({nodes}) {
        return (
            <>
            {nodes.map(node => (
                <TreeNode node={node} key={node.id} />
            ))}
            </>
        );
    }

    return (
        <Box display="flex" alignItems="flex-start">
            <Box flexGrow={1}>
                <CustomTreeView
                    className={`thin-scrollbar`}
                    defaultCollapseIcon={<IconButton size="small"><FontAwesomeIcon icon={["fas", "chevron-down"]}  className="primary" size="sm"/></IconButton>}
                    defaultExpandIcon={<IconButton size="small"><FontAwesomeIcon icon={["fas", "chevron-right"]}  className="primary" size="sm"/></IconButton>}
                    expanded={expanded}
                    onNodeToggle={(_, nodes) => setExpanded(nodes)}
                >
                    <TreeNodes nodes={nodes} />
                </CustomTreeView>
            </Box>
        </Box>
    );
};

function leafIds(node) {
    return !node.children || node.children.length === 0
        ? [node.id]
        : node.children.map(leafIds).flat();
}

export default MultiSelectTree;